import {
  AppNoticeDto,
  NoticeType,
  AppNoticePayload,
  AppNoticeWire,
  fromWire,
} from "../types/appNotice.definition";
import {
  requestCreateAppNotice,
  requestDeleteAppNotice,
  requestGetAppNotices,
  requestUpdateAppNotice,
} from "../webclients/appNotice.client";

export const appNoticeApi = {
  getAppNotices: async (featureType?: NoticeType): Promise<AppNoticeDto[]> => {
    const response = await requestGetAppNotices(featureType);
    const wireList = (response.data ?? []) as AppNoticeWire[];
    return wireList.map(fromWire);
  },

  createAppNotice: async (data: AppNoticePayload): Promise<AppNoticeDto> => {
    const response = await requestCreateAppNotice(data);
    return fromWire(response.data as AppNoticeWire);
  },

  updateAppNotice: async (
    id: number,
    data: AppNoticePayload
  ): Promise<AppNoticeDto> => {
    const response = await requestUpdateAppNotice(id, data);
    return fromWire(response.data as AppNoticeWire);
  },

  deleteAppNotice: async (id: number): Promise<void> => {
    await requestDeleteAppNotice(id);
  },
};
